import { render, staticRenderFns } from "./FriendGroupList.vue?vue&type=template&id=34b77ec2&scoped=true"
import script from "./FriendGroupList.vue?vue&type=script&lang=js"
export * from "./FriendGroupList.vue?vue&type=script&lang=js"
import style0 from "./FriendGroupList.vue?vue&type=style&index=0&id=34b77ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b77ec2",
  null
  
)

export default component.exports